import React from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import { CrumbTitle } from "./CrumbTitles";
import { RandomTextSkeleton } from "../../Skeleton/RandomTextSkeleton";

const useStyles = makeStyles((theme) => ({
  link: {
    textDecoration: "none",
    color: "dimgray",
    cursor: "pointer",
  },
  activeLink: {
    textDecoration: "none",
    color: "black",
    fontWeight: "600",
  },
}));

export default function Breadcrumb({
  pageTitle,
  isLoading = false,
  customBreadcrumbs = [],
}) {
  const classes = useStyles();
  const pathname = window.location.pathname;
  const pathArr = pathname.split("/");

  const handlePath = (index) => {
    var retVal = "";
    for (var x = 1; x <= index; x++) {
      retVal += "/" + pathArr[x];
    }
    return retVal;
  };

  const handleCustomPath = (route) => {
    var retVal = "";
    retVal += "/" + route;
    return retVal;
  };

  if (customBreadcrumbs.length > 0) {
    return (
      <Breadcrumbs className={classes.root}>
        {customBreadcrumbs.map((breadcrumb, index) => {
          return (
            <Link
              className={classes.link}
              to={() => handleCustomPath(breadcrumb.route)}
              key={index}
            >
              {breadcrumb.breadCrumbName}
            </Link>
          );
        })}
        <span className={classes.activeLink} key={customBreadcrumbs.length}>
          {pageTitle}
        </span>
      </Breadcrumbs>
    );
  } else {
    return (
      <>
        {!isLoading ? (
          <Breadcrumbs className={classes.root}>
            {pathArr.map((path, index) =>
              index !== 0 ? (
                index !== pathArr.length - 1 ? (
                  <Link
                    className={classes.link}
                    to={() => handlePath(index)}
                    key={index}
                  >
                    {CrumbTitle(path)}
                  </Link>
                ) : (
                  <span className={classes.activeLink} key={index}>
                    {pageTitle ?? CrumbTitle(path)}
                  </span>
                )
              ) : null
            )}
          </Breadcrumbs>
        ) : (
          <RandomTextSkeleton />
        )}
      </>
    );
  }
}
